import { Component, Input } from '@angular/core';
import { InputComponentType } from 'src/app/ui/form/input/InputComponentType';

@Component({
  selector: 'apc-extra-fields-custom-field-form',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss']
})
export class CustomFieldComponent {
  @Input() public form: any;
  @Input() public typesDropdown: any;

  public inputType: InputComponentType = 'text';
  public typeDescription: string = '';

  ngOnInit() {
    console.log(this.form)
    if (this.form && this.form.value.extraTypeCode) {
      let customType = this.typesDropdown.find((el) => el.identifier == this.form.value.extraTypeIdentifier);
      this.setInputType(customType.customFieldType);
      if (customType) {
        this.typeDescription = customType.description;
      }
    }
  }

  typeChange() {
    let customType = this.typesDropdown.find((el) => el.identifier == this.form.value.extraTypeIdentifier);
    this.typeDescription = customType.description;
    this.setInputType(customType.customFieldType);
    if (customType.customFieldType === 'BOOLEAN') {
      this.form.controls.value.patchValue(false);
    } else {
      this.form.controls.value.patchValue(null);
    }
    this.form.updateValueAndValidity();
    this.form.markAsDirty();
  }

  findDropdownRenderValue() {
    let findObject = this.typesDropdown.find((el) => el.identifier == this.form.value.extraTypeIdentifier);
    return findObject ? findObject.name : '';
  }

  setInputType(val) {
    switch (val) {
      case 'DATE':
      case 'DATE_TYPE':
      case 'CUSTOM_FIELD_DATE':
        this.inputType = 'date';
        break;
      case 'STRING':
      case 'CUSTOM_FIELD_STRING':
        this.inputType = 'text';
        break;
      case 'CUSTOM':
        this.inputType = 'text';
        break;
      case 'INT':
      case 'FLOAT':
      case 'CUSTOM_FIELD_FLOAT':
      case 'CUSTOM_FIELD_INT':
        this.inputType = 'number';
        break;
      case 'BOOLEAN':
      case 'CUSTOM_FIELD_BOOLEAN':
        this.inputType = 'switch';
        break;
      default:
        this.inputType = 'text';
        break;
    }
  }

  toggleAlert() {
    this.form.controls['dateEnd'].setErrors(null);
  }
}
